import React, { useEffect } from "react"
import { Link } from "gatsby"
import gsap from "gsap"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Animation from "../components/animation.jsx"
import { Player } from "@lottiefiles/react-lottie-player"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import LandingPageAnimation from "../lottie/landing-page-video";
import WebPortalAnimation from "../lottie/web";
import MobileAppAnimation from "../lottie/mobile";
import IllustrationAnimation from "../lottie/illustration";
import BrandingAnimation from "../lottie/branding";
import MotionAnimation from "../lottie/motion";
import Footer from "../components/footer";
import Transition from "./transition";
import MeetUs from "../images/meet-us.svg";
import RedseerLogo from "../images/redseer-logo.png"
import CaseStudyBannerImage from "../images/redseer-banner.png"

// import LandingPageAnimationVideo from "../images/Landing-page-animation-video.mp4"
// import VideoPlayer from "./videoPlayer"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true })
      }
    }
  }

  footerText = () => {
    return (
      <>
        We love to talk.
        <br />
        We are even better listeners.
      </>
    )
  }

  render() {
    return (
      <Layout hideNavigator>
        <SEO
          title="We design brands, build mobile and web apps, platforms, portals and websites"
          pathname={this.props.location.pathname}
        />
        <div className="container-fluid home-page">
          <section className="landing-head-section">
            <div className="container">
              <div className="row align-items-center banner-section">
                <div className="col-md-6 banner-section-heading">
                  <Transition
                    data={
                      <>
                        <h1 className="text-white">
                          Humanizing technology beautifully
                        </h1>
                        <p className="text-white pt-3">
                          When we design brands, build apps, platforms, portals
                          and websites. We keep it simple while delivering
                          results & delighting customers.
                          <br />
                          For you. Your customers. Your business.
                        </p>
                      </>
                    }
                  ></Transition>
                </div>
                <div className="col-md-6 play-annimation">
                  <Player
                    autoplay
                    loop={true}
                    src={LandingPageAnimation}
                  ></Player>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <div
                className="row p-3 align-items-center "
                style={
                  this.state.isMobile
                    ? { minHeight: "400px" }
                    : { minHeight: "800px" }
                }
              >
                <div className="col-md-7">
                  <Transition
                    data={
                      <>
                        <h1 className="mb-3">
                          A Tango of Design & Tech.
                          <br />
                          With Process. With Rigour.
                        </h1>
                        <p>
                          We make design and technology dance in unison!
                          Sometimes, even be out-of step – to innovate, to push
                          the envelope. We follow processes to lead the way in
                          design and technology.
                        </p>
                      </>
                    }
                  ></Transition>
                </div>
              </div>
            </div>
          </section>
          <section className="case-study-banner-section ">

            <div className="container">
              <div
                className="row align-items-center justify-content-center faster-fit"
                style={{ minHeight: "600px" }}
              >
                <div className="col-md-4 p-3">
                  <Transition
                    data={
                      <>
                        <img
                          className="faster-fit-logo pb-3"
                          style={{ width: "40%" }}
                          src={RedseerLogo}
                          alt="Redseer"
                        />
                        <p className="text-white pt-2 pb-3">
                          RedSeer is a nationwide leading consulting company
                          with 9 out of 10 internet companies in India choosing
                          them for their IPO journey. Mobiux helped RedSeer
                          translate their brand vision into a contemporary,
                          client focused and interactive website.
                        </p>
                        {/* <Link to="/works" className="text-white mt-5">
                          <p style={{ fontWeight: "bold" }}>
                            View our latest works
                          </p>
                        </Link> */}
                        <AniLink
                          cover
                          direction="down"
                          bg="#000000"
                          duration={1}
                          to="/redseer"
                          className="text-white mt-5"
                        >
                          <p style={{ fontWeight: "bold" }}>View case study</p>
                        </AniLink>
                      </>
                    }
                  />
                </div>
                <div className="col-md-8 mt-auto">
                  <img
                    className=""
                    style={{ width: "100%" }}
                    src={CaseStudyBannerImage}
                    alt="redseer"
                  />
                  {/* <GenericImage filename="faster-fit.png" /> */}
                </div>
              </div>
            </div>
          </section>

          <section className="have-an-idea">
            <div className="container mt-5">
              <div className="row mt-5 p-2 align-items-center">
                <div className="col-md-6 ideas">
                  <Transition
                    data={
                      <>
                        <h1>
                          Our Skills. Our Services.
                          <br />
                          Your Success.
                        </h1>
                      </>
                    }
                  />
                </div>
                <div className="col-md-6 ideas">
                  <div className="row align-items-center">
                    <div className="col-7">
                      <Animation data={WebPortalAnimation} />
                    </div>
                    <div className="col-5">
                      <Transition
                        data={
                          <>
                            <AniLink
                              cover
                              direction="down"
                              bg="#000000"
                              duration={1}
                              to="/offerings/#website"
                            >
                              <h6>Websites & Apps</h6>
                            </AniLink>
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 ideas">
                  <div className="row align-items-center">
                    <div className="col-7">
                      <Animation data={MobileAppAnimation} />
                    </div>
                    <div className="col-5">
                      <Transition
                        data={
                          <>
                            <AniLink
                              cover
                              direction="down"
                              bg="#000000"
                              duration={1}
                              to="/offerings/#mobile-app"
                            >
                              <h6>Mobile Apps</h6>
                            </AniLink>
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 ideas">
                  <div className="row align-items-center">
                    <div className="col-7">
                      {/* <Lottie options={IllustrationA}/> */}
                      <Animation data={IllustrationAnimation} />
                    </div>
                    <div className="col-5">
                      <Transition
                        data={
                          <>
                            <AniLink
                              cover
                              direction="down"
                              bg="#000000"
                              duration={1}
                              to="/offerings/#illustration"
                            >
                              <h6>Illustration</h6>
                            </AniLink>
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 ideas">
                  <div className="row align-items-center">
                    <div className="col-7">
                      {/* <Lottie options={BrandingA}/> */}
                      <Animation data={BrandingAnimation} />
                    </div>
                    <div className="col-5">
                      <Transition
                        data={
                          <>
                            <AniLink
                              cover
                              direction="down"
                              bg="#000000"
                              duration={1}
                              to="/offerings/#branding"
                            >
                              <h6>Branding</h6>
                            </AniLink>
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 ideas">
                  <div className="row align-items-center">
                    <div className="col-7">
                      {/* <Lottie options={MotionA}/> */}
                      <Animation data={MotionAnimation} />
                    </div>
                    <div className="col-5">
                      <Transition
                        data={
                          <>
                            <AniLink
                              cover
                              direction="down"
                              bg="#000000"
                              duration={1}
                              to="/offerings/#motion"
                            >
                              <h6>Motion</h6>
                            </AniLink>
                          </>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="meet-us mt-2 p-2">
            <div className="container">
              <div
                className="row align-items-center "
                style={
                  this.state.isMobile
                    ? { minHeight: "400px" }
                    : { minHeight: "700px" }
                }
              >
                <div className="col-md-6 p-4">
                  <Transition
                    data={
                      <>
                        <h1>RGB meets Smart-code & 50 others</h1>
                        <p>
                          We are playing with coding and colours. We are
                          engineers, designers, illustrators, and full stack
                          developers. Solving problems here and now, and
                          building the future.
                        </p>
                        <h2
                          className="mt-5"
                          style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            fontFamily: "Raleway",
                          }}
                        >
                          <AniLink
                            cover
                            direction="down"
                            bg="#000000"
                            duration={1}
                            to="/company"
                          >
                            Meet us
                          </AniLink>
                        </h2>
                      </>
                    }
                  />
                </div>
                <div className="col-md-6 p-3 text-center">
                  <img
                    className=""
                    style={{ width: "80%" }}
                    src={MeetUs}
                    alt="Meet-us"
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer contactTitle={this.footerText()} />
        </div>
      </Layout>
    )
  }
}
